import { render, staticRenderFns } from "./SlackAddChannelForm.vue?vue&type=template&id=27096a9c"
import script from "./SlackAddChannelForm.vue?vue&type=script&lang=js"
export * from "./SlackAddChannelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports